export const AUDIT_ACTIONS = {
    authLogin: "auth.login",
    authLoginFailed: "auth.login_failed",
    authLogout: "auth.logout",
    userCreate: "user.create",
    userRoleChange: "user.role_change",
    userActivate: "user.activate",
    userDeactivate: "user.deactivate",
    attachmentUpload: "attachment.upload",
    attachmentDownload: "attachment.download",
    attachmentDelete: "attachment.delete",
    customerCreate: "customer.create",
    customerUpdate: "customer.update",
    customerArchive: "customer.archive",
    customerUnarchive: "customer.unarchive",
    contactCreate: "contact.create",
    contactUpdate: "contact.update",
    contactDelete: "contact.delete",
    addressCreate: "address.create",
    addressUpdate: "address.update",
    addressDelete: "address.delete",
    activityCreate: "activity.create",
    taskCreate: "task.create",
    taskComplete: "task.complete",
    taskReopen: "task.reopen",
    workCenterCreate: "work_center.create",
    materialCreate: "material.create",
    productCreate: "product.create",
    productRevisionCreate: "product.revision_create",
    rfqCreate: "rfq.create",
    quoteCreate: "quote.create",
    quoteSend: "quote.send",
    quoteRevise: "quote.revise",
    quoteAccept: "quote.accept",
    quoteDecline: "quote.decline",
    salesOrderCreate: "sales_order.create",
    jobCreate: "job.create",
    jobRelease: "job.release",
    jobHold: "job.hold",
    jobResume: "job.resume",
    jobReady: "job.ready_for_delivery",
    jobComplete: "job.complete",
    jobCancel: "job.cancel",
    jobIssueRaise: "job.issue_raise",
    jobIssueResolve: "job.issue_resolve",
    operationStart: "operation.start",
    operationPause: "operation.pause",
    operationResume: "operation.resume",
    operationComplete: "operation.complete",
    operationBlock: "operation.block",
    operationUnblock: "operation.unblock",
    productionRecord: "production.record",
    stockLocationCreate: "stock_location.create",
    stockAdjust: "stock.adjust",
    stockIssue: "stock.issue",
    stockReturn: "stock.return",
    stockReverse: "stock.reverse",
    supplierCreate: "supplier.create",
    purchaseOrderCreate: "purchase_order.create",
    purchaseOrderReceive: "purchase_order.receive",
    purchaseOrderCancel: "purchase_order.cancel",
    expenseCategoryCreate: "expense_category.create",
    invoiceCreate: "invoice.create",
    invoiceIssue: "invoice.issue",
    invoiceVoid: "invoice.void",
    paymentCreate: "payment.create",
    paymentReverse: "payment.reverse",
    expenseCreate: "expense.create",
    expenseReverse: "expense.reverse",
    importCommit: "import.commit",
};
export const ATTACHMENT_OWNER_TYPES = [
    "customer",
    "quote",
    "sales_order",
    "job",
    "purchase_order",
    "goods_receipt",
    "invoice",
    "payment",
    "expense",
    "other",
];
//# sourceMappingURL=audit.js.map